// src/components/toast/loading.js
import { writable } from 'svelte/store';

export const loadingStore = writable({
    visible: false,
    text: 'Đang xử lý...',
    progress: null
});

function show(
    text = 'Đang xử lý...',
    progress = null
) {
    loadingStore.set({
        visible: true,
        text,
        progress
    });
}

function hide() {
    loadingStore.set({
        visible: false,
        text: '',
        progress: null
    });
}

function update(text, progress = null) {
    loadingStore.update((state) => ({
        ...state,
        text,
        progress
    }));
}

async function withLoading(
    promise,
    text = 'Đang xử lý...'
) {
    show(text);

    try {
        return await promise;
    } finally {
        hide();
    }
}

async function run(
    callback,
    text = 'Đang xử lý...'
) {
    show(text);

    try {
        return await callback();
    } finally {
        hide();
    }
}

export {
    show,
    hide,
    update,
    withLoading,
    run
};

export const loading = {
    show,
    hide,
    update,
    withLoading,
    run,

    save(text = 'Đang lưu dữ liệu...') {
        show(text);
    },

    load(text = 'Đang tải dữ liệu...') {
        show(text);
    },

    delete(text = 'Đang xoá dữ liệu...') {
        show(text);
    },

    upload(text = 'Đang tải tệp lên...') {
        show(text);
    },

    download(text = 'Đang tải dữ liệu...') {
        show(text);
    },

    print(text = 'Đang tạo báo cáo...') {
        show(text);
    },

    sync(text = 'Đang đồng bộ dữ liệu...') {
        show(text);
    }
};

// await loading.withLoading(
//   api.post('/api/user', data),
//   'Đang lưu người dùng...'
// );

// await loading.run(async () => {
//   await api.post('/api/user', data);
//   await api.post('/api/log', {});
// }, 'Đang lưu dữ liệu...');

